import IndigoApi from 'communication/IndigoApi';
import RequestProgressService from 'requestProgress/RequestProgressService';
import IndigoUser from 'communication/types/IndigoUser';
import { ApiRequestOptions } from 'communication/ApiCallInfo';

interface LayoutManagementServiceOptions {
    indigoApi: IndigoApi;
    requestProgressService: RequestProgressService;
}

export const getShareUsersRequestKey = 'getShareUsers';

export default class ShareUsersService {
    private requestProgressService: RequestProgressService;
    private indigoApi: IndigoApi;

    public constructor(options: LayoutManagementServiceOptions) {
        this.indigoApi = options.indigoApi;
        this.requestProgressService = options.requestProgressService;
    }

    public getShareUsers: () => Promise<IndigoUser[]> = async () => {
        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.getShareUsers(options);
        return await this.requestProgressService.invokeAndMonitorRequest(
            getShareUsersRequestKey,
            apiCall
        );
    };
}
